import { EditUser } from './EditUser.main';

export { EditUser };
